import {
  PLAYER_PORTALS_MODELS,
  MEMBERSHIP_MODELS,
} from '@r-and-a-shared-ui/common-kontent-client';
import {
  getFirstMappedLinkedItemOrDefault,
  getMappedLinkedItems,
} from './utils/component-mapping-helpers';

import {
  cookie_settings,
  cookie_popup,
} from 'libs/core-data-mapping/src/lib/kontent_ai_mapping';

export const player_portals_configuration = (
  input: PLAYER_PORTALS_MODELS.PlayerPortalsConfiguration | undefined,
) => {
  if (!input || !input?.elements) {
    return undefined;
  }

  const { elements } = input;

  return {
    cookiesSettings: cookie_settings(
      elements?.cookie_settings
        ?.linkedItems?.[0] as PLAYER_PORTALS_MODELS.CookiesSettings &
        MEMBERSHIP_MODELS.CookiesSettings,
    ),
    cookiesPopup: cookie_popup(
      elements?.cookie_popup
        ?.linkedItems?.[0] as PLAYER_PORTALS_MODELS.CookiesPopup &
        MEMBERSHIP_MODELS.CookiesPopup,
    ),
    playerPortals: {
      availableChampionships: getMappedLinkedItems(
        elements?.available_championships,
      ),
    },
    qualifyingPortal: {
      landingPageLink: getFirstMappedLinkedItemOrDefault(elements.landing_page),
    },
  };
};

export default player_portals_configuration;
